import { useMarketIndicesCardController } from "./MarketIndicesCard.controller";
import { MarketIndicesCardPresentation } from "./MarketIndicesCard.pres";

export const MarketIndicesCard = () => {
  const { rows, isLoading } = useMarketIndicesCardController();

  return <MarketIndicesCardPresentation rows={rows} isLoading={isLoading} />;
};
